export const categories = [
  { id: 'wanghong-tafang', name: '网红塌房', slug: 'wanghong-tafang', icon: 'ri-alert-line', description: '网红翻车现场实录，最新塌房事件汇总' },
  { id: 'yule-bagua', name: '娱乐八卦', slug: 'yule-bagua', icon: 'ri-chat-smile-2-line', description: '娱乐圈最新八卦，明星动态一手掌握' },
  { id: 'zhibo-fanche', name: '直播翻车', slug: 'zhibo-fanche', icon: 'ri-live-line', description: '直播间名场面，翻车合集不容错过' },
  { id: 'lianyuyin', name: '录音证据', slug: 'lianyuyin', icon: 'ri-voiceprint-line', description: '独家录音爆料，真相就在声音里' },
  { id: 'shipin-baoliao', name: '视频爆料', slug: 'shipin-baoliao', icon: 'ri-video-line', description: '实锤视频爆料，眼见为实' },
  { id: 'shenbian-shi', name: '身边事', slug: 'shenbian-shi', icon: 'ri-user-location-line', description: '身边人的真实爆料故事' },
];

export const articles = [
  {
    id: 1,
    slug: 'dingji-wanghong-zhibo-fanche',
    title: '顶级网红直播翻车现场：被实锤造假后崩溃大哭',
    excerpt: '近日，某千万粉丝级别的大网红在直播中意外翻车，被网友实锤播放造假视频，直播间在线人数瞬间跌破谷底...',
    content: `<p>近日，某千万粉丝级别的大网红在直播中意外翻车，整场直播引来了超过300万观众围观，但最终以一场"人间惨剧"收场。</p><p>据悉，该网红在直播时展示了一段所谓的"独家街拍视频"，声称自己偶遇某顶流明星与其密会。然而，眼尖的网友迅速发现，这段视频实际上是半年前某剧组的拍摄花絮，被恶意剪辑后当作"实锤"发出。</p><p><strong>现场气氛一度尴尬至极。</strong>面对弹幕中铺天盖地的质疑，该网红先是强装镇定，随后情绪崩溃，在直播间当众大哭，并声称自己也是"受害者"，被线人欺骗。但网友们并不买账，纷纷刷屏"退钱""取关"。</p><p>据第三方数据平台统计，该网红在本次事件后，24小时内掉粉超过200万，合作品牌也纷纷解约。业内人士分析认为，这将是今年直播圈最大的一次翻车事件。</p><p>有消息人士透露，目前已有多个品牌方向该网红发出律师函，要求赔偿因形象受损造成的商业损失。而该网红的团队则连夜开会商讨危机公关方案，但目前看来效果甚微。</p>`,
    category: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20a%20live%20streaming%20studio%20with%20bright%20ring%20lights%20and%20a%20person%20looking%20distressed%20in%20front%20of%20a%20camera%20setup%2C%20warm%20dramatic%20lighting%2C%20editorial%20photography%20style%2C%20clean%20composition%2C%20emotional%20atmosphere&width=800&height=450&seq=article-img-01&orientation=landscape',
    author: '吃瓜前线记者',
    date: '2026-07-06',
    views: '128.6万',
    comments: 35642,
    tags: ['直播翻车', '网红造假', '掉粉200万'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 2,
    slug: 'damingxing-yinsi-baoliao',
    title: '某知名明星深夜密会神秘女子，婚变传闻再次升级',
    excerpt: '据知情人爆料，某一线男星近日深夜被拍到与一名神秘女子出入酒店，而就在上个月，他与妻子的婚变传闻才刚刚平息...',
    content: `<p>娱乐圈的瓜一个接一个。上个月刚刚平息婚变传闻的某一线男星，近日又被拍到深夜与一名神秘女子出入某五星级酒店。</p><p>据目击者称，该男星当晚身穿黑色连帽衫，刻意压低帽檐，与一名身着红色连衣裙的女子从酒店侧门走出，随后一同乘坐保姆车离开。整个过程持续约五分钟，两人全程保持距离，但举止间透露出不寻常的亲密感。</p><p><strong>值得注意的是，</strong>就在上个月，该男星与妻子刚刚联合发布声明，否认了此前网络上流传的婚变传闻，称两人感情稳定，家庭和睦。然而此次深夜密会的照片一经曝光，立即引发了新一轮的热议。</p><p>截至目前，该男星及其团队尚未对此次爆料做出任何回应。而其妻子的社交媒体账号评论区已经彻底沦陷，大量粉丝涌入留言询问真相。</p>`,
    category: 'yule-bagua',
    image: 'https://readdy.ai/api/search-image?query=A%20luxury%20hotel%20entrance%20at%20night%20with%20soft%20golden%20lighting%2C%20two%20silhouettes%20walking%20near%20a%20black%20luxury%20car%2C%20paparazzi%20photography%20style%2C%20dramatic%20atmosphere%2C%20cinematic%20composition&width=800&height=450&seq=article-img-02&orientation=landscape',
    author: '娱乐圈观察员',
    date: '2026-07-05',
    views: '96.3万',
    comments: 28901,
    tags: ['明星八卦', '婚变', '深夜密会'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 3,
    slug: 'zhibo-daihuo-jiahuo',
    title: '直播带货又出事！知名主播售卖假货被消费者集体维权',
    excerpt: '一场声势浩大的直播带货活动被爆出卖假货，涉及金额高达数千万，目前已有上百名消费者联合发起维权...',
    content: `<p>直播带货行业再次迎来信任危机。近日，某知名带货主播在其直播间售卖的"进口高端护肤品"被专业机构鉴定为假冒伪劣产品，引发了一场大规模的消费者维权行动。</p><p>据了解，该主播在直播中声称这批护肤品是"品牌方直供""100%正品保证"，并以远低于市场价的价格进行促销。在主播的极力推荐下，超过5000名消费者下单购买，涉及金额高达2800万元。</p><p><strong>然而，</strong>第一批收到货的消费者发现产品包装粗糙、质地异常，与正品存在明显差异。随后有消费者将产品送往第三方检测机构鉴定，结果显示多项指标不符合正品标准，确认为假冒产品。</p><p>目前，已有超过200名消费者组成维权群，向市场监管部门投诉，并准备提起集体诉讼。该主播则在事件发酵后第一时间删除了所有相关直播回放，至今未做正面回应。</p>`,
    category: 'zhibo-fanche',
    image: 'https://readdy.ai/api/search-image?query=A%20live%20streaming%20e-commerce%20setup%20with%20beauty%20products%20displayed%20on%20a%20table%2C%20warm%20studio%20lighting%2C%20professional%20product%20photography%20style%2C%20clean%20aesthetic%2C%20modern%20minimalist%20composition&width=800&height=450&seq=article-img-03&orientation=landscape',
    author: '消费权益报道',
    date: '2026-07-04',
    views: '85.7万',
    comments: 45231,
    tags: ['直播带货', '假货维权', '消费者权益'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 4,
    slug: 'wanghong-beihou-ziben',
    title: '揭秘网红背后的资本游戏：MCN机构如何操控你的注意力',
    excerpt: '一场关于MCN机构与网红之间利益关系的深度调查，揭示了这个行业不为人知的资本运作内幕...',
    content: `<p>在光鲜亮丽的网红经济背后，隐藏着一套精密运转的资本体系。近日，一份关于国内头部MCN机构的深度调查报告，揭开了这个行业不为人知的一面。</p><p>调查报告指出，目前国内排名前十的MCN机构控制了超过70%的头部网红资源。这些机构不仅负责网红的日常运营，更深度介入内容的策划、制作与推广，形成了一个从内容生产到商业变现的闭环。</p><p><strong>更令人震惊的是，</strong>一些MCN机构为了快速捧红签约主播，不惜采取"数据造假""恶意炒作""制造对立话题"等手段来吸引公众注意力。在某机构的内部培训资料中，甚至出现了"黑红也是红""负面流量也是流量"等令人咋舌的操作指南。</p><p>业内人士表示，随着监管部门的介入和相关法规的完善，这种野蛮生长的状态正在逐步改善，但MCN行业的规范化仍然任重道远。</p>`,
    category: 'shenbian-shi',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20corporate%20office%20with%20glass%20walls%20and%20sleek%20design%2C%20data%20charts%20on%20screens%2C%20professional%20atmosphere%2C%20editorial%20photography%2C%20clean%20composition%2C%20soft%20natural%20lighting&width=800&height=450&seq=article-img-04&orientation=landscape',
    author: '深度调查组',
    date: '2026-07-03',
    views: '72.1万',
    comments: 18345,
    tags: ['MCN机构', '资本运作', '网红经济'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 5,
    slug: 'luyin-baoliao-jingren-neimu',
    title: '独家录音曝光！某顶流团队内部会议内容令人震惊',
    excerpt: '一段长达40分钟的录音文件在网络上疯传，记录了某顶流艺人团队内部会议的真实对话，内容让人大跌眼镜...',
    content: `<p>昨日深夜，一段长达40分钟的录音文件在各大社交平台迅速传播。该录音据称记录了某顶流艺人团队内部会议的真实对话，内容涉及对竞争对手的打压策略以及对粉丝群体的操控手段。</p><p>录音中可以清晰地听到，该团队负责人详细部署了一套名为"围剿计划"的方案，目标直指同期出道的另一位艺人。方案中包括了买通营销号发布负面通稿、策划"黑热搜"、以及安排"假粉"在对方社交账号下恶意评论等具体操作。</p><p><strong>"粉丝是我们的武器，要学会利用他们。"</strong>这句话在录音中多次被提及，显示出该团队对粉丝群体的工具化态度。</p><p>截至目前发布，该录音的真实性尚未得到官方确认，但多位音频分析专家表示，录音中的声音特征与该团队公开露面的声音高度吻合。</p>`,
    category: 'lianyuyin',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20conference%20room%20with%20dim%20lighting%20and%20a%20recording%20device%20on%20a%20wooden%20table%2C%20mysterious%20atmosphere%2C%20investigative%20journalism%20style%2C%20dramatic%20shadows%2C%20tense%20mood&width=800&height=450&seq=article-img-05&orientation=landscape',
    author: '独家爆料组',
    date: '2026-07-02',
    views: '201.4万',
    comments: 89765,
    tags: ['录音爆料', '顶流艺人', '幕后黑手'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 6,
    slug: 'wanghong-qiankuan-taolu',
    title: '网红"哭穷"套路被拆穿：月入百万却拖欠员工工资',
    excerpt: '某知名网红长期在直播间哭穷博同情，却被前员工爆料月收入轻松过百万，却故意拖欠团队工资长达半年之久...',
    content: `<p>"家人们，我真的太难了，这个月又亏了。"这句话几乎是每个"哭穷系"网红的标配台词。然而，一位前员工的实名爆料，却彻底拆穿了这套虚伪的话术。</p><p>该前员工在社交媒体上发布了多张银行流水截图和微信聊天记录，显示其前雇主——某位拥有800万粉丝的网红——单月直播带货佣金收入就达到了126万元，但却以"公司经营困难"为由，拖欠包括该前员工在内的十几名团队成员工资长达六个月。</p><p><strong>"他一边在直播间哭穷，一边换了三辆豪车。"</strong>该前员工在爆料帖中写道。据其透露，这位网红去年全年的实际收入保守估计超过1500万元，所谓的"亏损"完全是为了博取粉丝同情而编造的谎言。</p><p>面对舆论压力，该网红发布了一则简短声明，称"正在积极处理相关事宜"，但未对具体问题进行回应。目前，劳动监察部门已介入调查。</p>`,
    category: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20living%20room%20with%20designer%20furniture%20and%20expensive%20decor%2C%20contrast%20between%20wealth%20and%20a%20sad%20expression%2C%20editorial%20photography%2C%20warm%20interior%20lighting%2C%20dramatic%20mood&width=800&height=450&seq=article-img-06&orientation=landscape',
    author: '吃瓜前线记者',
    date: '2026-07-01',
    views: '56.8万',
    comments: 22109,
    tags: ['网红哭穷', '拖欠工资', '人设崩塌'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 7,
    slug: 'xingjiu-gequ-chaoxi',
    title: '新晋歌手新歌被指抄袭，原作者跨国维权',
    excerpt: '一位国内新晋人气歌手的最新单曲被网友扒出与某国外小众歌手的作品高度相似，原作者已通过社交媒体发声...',
    content: `<p>音乐圈的抄袭风波再次引起关注。近日，一位国内新晋人气歌手发布的最新单曲，被网友发现与某国外小众独立音乐人三年前发布的歌曲在主旋律和编曲结构上高度相似。</p><p>音乐专业人士在对比两首歌曲后指出，两首歌不仅和弦进行几乎一致，连副歌部分的旋律线条也惊人地相似，相似度超过90%。</p><p><strong>"这是赤裸裸的抄袭。"</strong>原作者在发现此事后，通过社交媒体平台公开发声，表示将通过法律途径维护自己的权益。该声明获得了大量国内外乐迷的支持。</p><p>涉事歌手的经纪公司随后发布声明，称"已注意到相关讨论，正在与词曲作者核实创作过程"，但并未直接否认抄袭指控。</p>`,
    category: 'yule-bagua',
    image: 'https://readdy.ai/api/search-image?query=A%20recording%20studio%20with%20professional%20equipment%20and%20headphones%2C%20sheet%20music%20on%20a%20stand%2C%20warm%20creative%20atmosphere%2C%20music%20industry%20editorial%20photography%2C%20soft%20lighting%2C%20artistic%20composition&width=800&height=450&seq=article-img-07&orientation=landscape',
    author: '娱乐圈观察员',
    date: '2026-06-30',
    views: '43.2万',
    comments: 15678,
    tags: ['歌曲抄袭', '跨国维权', '版权争议'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 8,
    slug: 'meizhuang-bozhu-xujia-xuanchuan',
    title: '美妆博主被罚50万：虚假宣传面膜功效遭监管重拳出击',
    excerpt: '某拥有500万粉丝的美妆博主因在直播中虚假宣传面膜产品功效，被市场监管部门处以50万元罚款...',
    content: `<p>监管部门对直播带货行业的整治力度持续加大。近日，某拥有500万粉丝的美妆博主因虚假宣传被处以50万元罚款，成为今年因直播带货违规被处罚的典型案例之一。</p><p>据市场监管部门通报，该博主在直播中宣称其推荐的某品牌面膜"使用一次就能明显淡化色斑""三周彻底消除皱纹"，并出示了所谓的"临床实验数据"来佐证其说法。然而经调查，该博主出示的实验数据系伪造，产品本身也并未取得相关功效认证。</p><p><strong>除了罚款之外，</strong>该博主还被要求在直播间公开道歉，并被列入直播带货行业黑名单，三年内不得从事直播带货相关活动。</p><p>这一处罚结果在网络上引发广泛讨论，不少网友拍手叫好，认为这是净化直播带货行业的重要一步。</p>`,
    category: 'zhibo-fanche',
    image: 'https://readdy.ai/api/search-image?query=A%20beauty%20product%20display%20with%20skincare%20items%20on%20a%20marble%20surface%2C%20regulatory%20documents%20nearby%2C%20professional%20lighting%2C%20clean%20editorial%20style%2C%20crisp%20composition&width=800&height=450&seq=article-img-08&orientation=landscape',
    author: '消费权益报道',
    date: '2026-06-29',
    views: '38.5万',
    comments: 12034,
    tags: ['美妆博主', '虚假宣传', '监管处罚'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 9,
    slug: 'duanshiping-tai-neimu',
    title: '短视频平台推荐算法内幕曝光：你的时间就是这样被偷走的',
    excerpt: '一位前短视频平台算法工程师匿名爆料，揭示了平台如何通过精密算法设计来最大化用户停留时长...',
    content: `<p>你是否曾经刷短视频刷到凌晨三四点，明明很累却停不下来？这不是你的自制力问题，而是平台算法的"精心设计"。</p><p>一位自称曾在某头部短视频平台担任算法工程师的网友，近日在技术论坛上发布了一篇长文，详细揭示了短视频平台推荐算法背后的运作逻辑。据其描述，平台的推荐系统经过了数百次迭代优化，每一个细节都旨在最大化用户的停留时长。</p><p><strong>"我们的KPI不是让你看到好内容，而是让你停不下来。"</strong>该工程师写道。系统会精准计算用户的疲劳曲线，在用户即将退出时推送一条"极度诱人"的内容，将用户重新拉回来。这套被称为"钩子策略"的机制，据称能将用户平均停留时长提升40%以上。</p><p>这篇文章引发了广泛的社会讨论。多位心理学专家呼吁，平台应该承担更多的社会责任，而非单纯追求商业利益。</p>`,
    category: 'shenbian-shi',
    image: 'https://readdy.ai/api/search-image?query=A%20person%20holding%20a%20smartphone%20in%20a%20dark%20room%20with%20only%20the%20screen%20glowing%2C%20algorithmic%20patterns%20reflected%2C%20dystopian%20tech%20atmosphere%2C%20editorial%20photography%2C%20dramatic%20lighting&width=800&height=450&seq=article-img-09&orientation=landscape',
    author: '深度调查组',
    date: '2026-06-28',
    views: '168.9万',
    comments: 56789,
    tags: ['短视频', '算法揭秘', '用户成瘾'],
    isHot: true,
    isFeatured: false,
  },
];

export const hotTags = [
  '网红塌房',
  '直播翻车',
  '明星婚变',
  '录音曝光',
  '假货维权',
  'MCN内幕',
  '抄袭风波',
  '算法揭秘',
];

export const siteInfo = {
  name: '黑料吃瓜网',
  slogan: '24小时不打烊，点开即看独家吃瓜资源',
  description: '黑料吃瓜网是国内领先的娱乐八卦资讯聚合平台，聚焦91黑料吃瓜网、黑料吃瓜在线观看等热门搜索词。我们提供最新、最全的黑料吃瓜视频与爆料内容，涵盖网红塌房实录、明星八卦、直播翻车等丰富话题。',
  email: 'contact@heiliaochigua.com',
  year: 2026,
};